/*jshint esversion: 6 */

/**
 * @description initialize each class defined in /classes.
 * @requires /classes/dnneditor.class.js
 * @requires /classes/footer.class.js
 * @requires /classes/header.class.js
 * @requires /classes/helpers.class.js (static)
 * @requires /classes/menu.class.js
 * @requires /classes/notificationbanner.class.js
 * @requires /classes/phonenumber.class.js
 * @requires /classes/plugin-loader.class.js
 * @requires /classes/lazyscriptloader.class.js
 */

  
const debug = false;   // true: show debug messages, false: don't show debug messages

document.addEventListener('DOMContentLoaded', () => {

  if (debug) console.log('TRITON COMMERCE DEBUG LOG');
      initializeTriton();
});


function initializeTriton() {

  window.triton = {};

  window.triton.lazyScriptLoader = new LazyScriptLoader([
    {
      selector: 'review-carousel',
      src: 'https://www.tritoncommerce.com/portals/0/scripts/review-feed.min.js',
      rootMargin: '0px 0px 500px 0px',
      threshold: 0.01,
    }, 
    {
      selector: '[data-accordion-group]',
      src: 'https://www.tritoncommerce.com/Portals/0/scripts/clean-accordion.min.js',
        rootMargin: '150px',
      threshold: 0.1,
      callback: () => { PluginLoader.initAccordion(); }
    },
    {
    
      selector: '.swiper',
      src: 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-element-bundle.min.js',
        rootMargin: '150px',
      threshold: 0.1,
      callback: () => { PluginLoader.initSlider(); }
    },
      {
    
      selector: '[data-tab-group]',
      src: 'https://www.tritoncommerce.com/Portals/0/scripts/clean-tabs.min.js',
      rootMargin: '150px',
      threshold: 0.1,
      callback: () => { PluginLoader.initTabs(); }
    },
     {
      selector: '[data-fslightbox]',
      src: 'https://www.tritoncommerce.com/Portals/0/scripts/fslightbox.js',
      rootMargin: '150px',
      threshold: 0.1,
      callback: () => { PluginLoader.initLightbox(); }
    }
  ]);

  window.triton.pluginLoader = new PluginLoader(debug);
  window.triton.phoneNumber = new PhoneNumber(debug);
  window.triton.dnneditor = new DNNEditor(debug);
  window.triton.header = new Header(debug);
  window.triton.menu = new Menu(debug);
  window.triton.utm = new UTM(debug);
  window.triton.notificationBanner = new NotificationBanner(debug);
}
